import { FC } from "react";

interface PropType {
  component: JSX.Element;
  categoryname: string;
  role: string;
}

const HideRoute: FC<PropType> = ({
  component: Component,
  categoryname: categoryname,
  role: role,
}) => {
  if (role === "Admin") {
    if (
      categoryname === "Currency Dashboard" ||
      categoryname === "Price Dashboard" ||
      categoryname === "TeaRetina Dashboard" ||
      categoryname === "TeaRetina Images Dashboard" ||
      categoryname === "Benchmark Dashboard" ||
      categoryname === "File Upload" ||
      categoryname === "File Upload - Export" ||
      categoryname === "File Upload - View" ||
      categoryname === "Client Management" ||
      categoryname === "User Management" ||
      categoryname === "Control Center" ||
      categoryname === "Labeling"
    ) {
      return Component;
    }
  }

  if (role === "Standard User") {
    if (
      categoryname === "Currency Dashboard" ||
      categoryname === "Price Dashboard" ||
      categoryname === "TeaRetina Dashboard" ||
      categoryname === "TeaRetina Images Dashboard" ||
      categoryname === "Benchmark Dashboard" ||
      categoryname === "File Upload - Export" ||
      categoryname === "Labeling"
    ) {
      return Component;
    }
  }

  if (role === "Operator") {
    if (
      categoryname === "File Upload" ||
      categoryname === "File Upload - Export" ||
      categoryname === "File Upload - View" ||
      categoryname === "Labeling"
    ) {
      return Component;
    }
  }

  return <></>;
};

export default HideRoute;
